import { StyleSheet } from 'react-native';
import { colors } from '../../shared/theme/colors'
import { spacing } from '../../shared/theme/spacing'
import { ticketColors } from '../../shared/theme/ticketColors'
import { typography } from '../../shared/theme/typography';

export const mercadoPagoQrModalStyles = StyleSheet.create({
  modalCard: {
    maxWidth: 440,
    paddingVertical: spacing.lg,
    paddingHorizontal: spacing.lg,
    gap: spacing.md,
  },
  sheetCard: {
    width: '100%',
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    borderTopWidth: 1,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderColor: ticketColors.ruleSoft,
    paddingTop: 8,
    overflow: 'hidden',
    zIndex: 1,
    flexDirection: 'column',
  },
  sheetHeader: {
    paddingHorizontal: 18,
    marginBottom: 8,
  },
  sheetBody: {
    paddingHorizontal: 18,
    paddingBottom: spacing.lg,
    gap: spacing.md,
  },
  grabber: {
    width: 28,
    height: 3,
    borderRadius: 2,
    backgroundColor: ticketColors.rule,
    alignSelf: 'center',
    marginTop: 2,
    marginBottom: 12,
  },
  contentFullWidth: {
    alignSelf: 'stretch',
    width: '100%',
  },
  closeConfirmActions: {
    alignSelf: 'stretch',
    width: '100%',
    gap: spacing.sm,
  },
  successBlock: {
    width: '100%',
    alignItems: 'center',
    gap: spacing.md,
  },
  hint: {
    textAlign: 'center',
    lineHeight: 22,
    color: colors.textSecondary,
  },
  hintStrong: {
    color: colors.textPrimary,
    fontWeight: '600',
  },
  statusRow: {
    width: '100%',
    alignItems: 'center',
    gap: spacing.xs,
  },
  amountHero: {
    ...typography.title3,
    fontVariant: ['tabular-nums'],
    color: colors.textPrimary,
  },
  countdownBarTrack: {
    width: '100%',
    height: 4,
    borderRadius: 2,
    backgroundColor: colors.border,
    overflow: 'hidden',
  },
  countdownBarFill: {
    height: '100%',
    backgroundColor: colors.accent,
  },
  countdownLabel: {
    fontSize: 13,
    color: colors.textMuted,
    fontVariant: ['tabular-nums'],
  },
  autoCloseTrack: {
    width: '100%',
    height: 3,
    borderRadius: 2,
    backgroundColor: colors.border,
    overflow: 'hidden',
    marginTop: spacing.sm,
  },
  autoCloseFill: {
    height: '100%',
    backgroundColor: colors.success,
  },
  warningPanel: {
    width: '100%',
    padding: spacing.md,
    borderRadius: 10,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: colors.border,
    backgroundColor: colors.surface,
    gap: spacing.sm,
  },
  warningTitle: {
    ...typography.body,
    fontWeight: '600',
    color: colors.textPrimary,
  },
  warningBody: {
    ...typography.caption,
    color: colors.textSecondary,
    lineHeight: 20,
  },
  fiscalChip: {
    fontSize: 12,
    color: colors.textMuted,
    textAlign: 'center',
  },
  saleRef: {
    fontSize: 12,
    color: colors.textMuted,
    fontVariant: ['tabular-nums'],
  },
  actionStack: {
    width: '100%',
    gap: spacing.sm,
    marginTop: spacing.xs,
  },
  primaryButton: {
    width: '100%',
    backgroundColor: colors.accentStrong,
    borderRadius: 10,
    paddingVertical: spacing.sm + 2,
    paddingHorizontal: spacing.md,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 44,
  },
  primaryButtonText: {
    ...typography.body,
    color: '#FFFFFF',
    fontWeight: '700',
    textAlign: 'center',
  },
  secondaryButton: {
    width: '100%',
    borderRadius: 10,
    paddingVertical: spacing.sm + 2,
    paddingHorizontal: spacing.md,
    borderWidth: 1,
    borderColor: colors.controlBorder,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.controlSurface,
    minHeight: 44,
  },
  secondaryButtonText: {
    ...typography.body,
    color: colors.textPrimary,
    fontWeight: '600',
    textAlign: 'center',
  },
  dangerButton: {
    width: '100%',
    borderRadius: 10,
    paddingVertical: spacing.sm + 2,
    paddingHorizontal: spacing.md,
    borderWidth: 1,
    borderColor: colors.danger,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.surface,
    minHeight: 44,
  },
  dangerButtonText: {
    ...typography.body,
    color: colors.danger,
    fontWeight: '700',
    textAlign: 'center',
  },
  errorBlock: {
    width: '100%',
    gap: spacing.xs,
  },
});
